// ============================================================
// 3D迷宫游戏 - 集中配置参数
// ============================================================

/** 玩家参数 */
export const PLAYER_HEIGHT = 1.6;
export const PLAYER_RADIUS = 0.35;
export const PLAYER_SPEED = 5.0;
export const PLAYER_SPRINT_MULT = 1.6;
export const PLAYER_COLLISION_STEP = 0.08;
export const MOUSE_SENSITIVITY = 0.002;

/** 迷宫参数 */
export const CELL_SIZE = 4.0;
export const WALL_HEIGHT = 3.0;
export const WALL_THICKNESS = 0.3;

/** 宝石参数 */
export const GEM_BOB_AMPLITUDE = 0.2;
export const GEM_ROTATE_SPEED = 1.5;
export const GEM_RADIUS = 0.35;
export const GEM_COLLECT_RADIUS = 1.2;

/** 出口参数 */
export const EXIT_HALF_WIDTH = 1.0;
export const EXIT_HEIGHT = 2.5;
export const EXIT_TRIGGER_RADIUS = 1.8;

/** 关卡配置 */
export interface LevelConfig {
  name: string;
  gridSize: number; // N×N 网格
  timeLimit: number; // 秒
  gemCount: number;
}

export const LEVELS: LevelConfig[] = [
  { name: '第1关', gridSize: 10, timeLimit: 90, gemCount: 8 },
  { name: '第2关', gridSize: 14, timeLimit: 120, gemCount: 15 },
  { name: '第3关', gridSize: 18, timeLimit: 150, gemCount: 25 },
];

/** 光照参数 */
export const SKY_COLOR = '#a8d8ea';
export const FOG_NEAR_RATIO = 1.2;
export const FOG_FAR_RATIO = 2.5;
export const AMBIENT_LIGHT_INTENSITY = 1.2;
export const HEMI_SKY_COLOR = '#f0f0e8';
export const HEMI_GROUND_COLOR = '#5a7a3a';
export const HEMI_INTENSITY = 0.7;
export const SUN_COLOR = '#fffef0';
export const SUN_INTENSITY = 1.8;
export const FLASHLIGHT_INTENSITY = 1.5;
export const FLASHLIGHT_RANGE = 12;
export const EXIT_LIGHT_COLOR = '#ffaa33';
export const EXIT_LIGHT_INTENSITY = 3.0;
export const EXIT_LIGHT_RANGE = 12;
